import { Cursor, ProfileItem } from 'api/search/search.types'
import { SearchItemPromo } from 'common-constants/promoCases'

export interface SearchListProfileState {
  items: (ProfileItem | SearchItemPromo)[]
  isEnd: boolean
  cursor: Cursor
  resultLoading: boolean
  resultLoaded: boolean
  initialLoaded: boolean
  lastPromoInsert: SearchItemPromo | undefined
}

export const initialState: SearchListProfileState = {
  items: [],
  isEnd: false,
  cursor: {
    negativeTags: null,
    searchId: 0,
    searcherOffset: 0,
    type: null,
  },
  resultLoaded: false,
  resultLoading: false,
  initialLoaded: false,
  lastPromoInsert: undefined,
}
